import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { MainChatRequest, MainChatResponse } from '../../../shared/models/generated';

@Service()
export class ChatService {
    readonly http = inject(HttpClient);

    chat(request: MainChatRequest) {
        return this.http.post<MainChatResponse>(`${environment.apiUrl}/api/agents/help-chat`, request);
    }
}
